module.exports = __webpack_public_path__ + "static/media/DetailsSecuritySolutionSecuDocuHandheldDetector.42e72c90.png";